<mat-form-field floatLabel="always" style="width: 100%;">
  <mat-label>Selecciona un rango de fechas</mat-label>

  <!-- Campo de rango de fechas -->
  <mat-date-range-input [rangePicker]="picker">
    <input 
      matStartDate 
      placeholder="Fecha inicio" 
      [(ngModel)]="dateRange.start" 
      [value]="null"
      (ngModelChange)="onChange()">
    <input 
      matEndDate 
      placeholder="Fecha fin" 
      [(ngModel)]="dateRange.end" 
      (ngModelChange)="onChange()">
  </mat-date-range-input>

  <!-- Toggle para mostrar el calendario -->
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

  <!-- Picker para el rango -->
  <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>